//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"HostName",1,1],[0,"OpcFileBrowser",1,0],[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0],[0,"ServerProgID",1,1],[0,"ServerType",1,1],[1,"UpdateTime",0,"Expression",1]],[[[],"DeleteTags",{},0,1],[[],"AddTags",{},0,1],[["numTags","tagName","tagType"],"GetAvailableItems",{},0,1],[["tagName","tagType"],"SetAvailableItems",{},2,1],[["numTags","attr"],"GetItemAttributes",{},0,1],[["attr"],"SetItemAttributes",{},1,1],[["numInstances"],"GetServerNames",{R_:{names:""}},0,1],[["names"],"SetServerNames",{},1,1],[["serverName","numTags"],"GetServerTags",{R_:{tagInfos:""}},1,1],[["serverName","ownerPart","numTags","tagInfos"],"GetServerInfos",{},2,1],[["serverName","numTags","tagInfos"],"GetServerTagsEx",{},1,0],[["serverName","tagInfos"],"SetServerTagsEx",{},2,0],[["serverName","ownerPart","tagInfos"],"SetServerInfos",{},3,1],[["numServers"],"GetServers",{R_:{serverInfos:""}},0,0],[["serverInfos"],"SetServers",{},1,0],[["progID"],"GetServerUpdateMethod",{R_:{pUpdateMethod:''}},1,0],[["progID","updateMethod"],"SetServerUpdateMethod",{},2,0],[["serverName","numTags","tagInfos"],"GetTags",{},1,0],[["serverName","tagInfos"],"SetTags",{},2,0],[["progID","strTagId"],"GetTagArrayDisplayName",{R_:{pArrayDisplayName:''}},2,0],[["progID","strTagId","pArrayDisplayName"],"SetTagArrayDisplayName",{},3,0]],[]];
SPLM.Mechatronics.OPCClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.OPCClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.OPCClientBuilder.TagAttribute = class{
    constructor(tagName,tagType,tagAccess){
        this.tagName=tagName;this.tagType=tagType;this.tagAccess=tagAccess;}
    get Tagname(){return this.tagName}
    set Tagname(val){this.tagName = val}
    get Tagtype(){return this.tagType}
    set Tagtype(val){this.tagType = val}
    get Tagaccess(){return this.tagAccess}
    set Tagaccess(val){this.tagAccess = val}
};

SPLM.Mechatronics.OPCClientBuilder.TagInfo = class{
    constructor(name,eIOType,eDataType){
        this.name=name;this.eIOType=eIOType;this.eDataType=eDataType;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
};

SPLM.Mechatronics.OPCClientBuilder.TagInfoEx = class{
    constructor(name,eIOType,dataTypeName){
        this.name=name;this.eIOType=eIOType;this.dataTypeName=dataTypeName;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Datatypename(){return this.dataTypeName}
    set Datatypename(val){this.dataTypeName = val}
};

SPLM.Mechatronics.OPCClientBuilder.ServerInfo = class{
    constructor(progID,hostName,updateTime,serverType){
        this.progID=progID;this.hostName=hostName;this.updateTime=updateTime;this.serverType=serverType;}
    get Progid(){return this.progID}
    set Progid(val){this.progID = val}
    get Hostname(){return this.hostName}
    set Hostname(val){this.hostName = val}
    get Updatetime(){return this.updateTime}
    set Updatetime(val){this.updateTime = val}
    get Servertype(){return this.serverType}
    set Servertype(val){this.serverType = val}
};

SPLM.Mechatronics.OPCClientBuilder.ServerOption = Object.freeze({
    "Local" : "Local", "Remote" : "Remote", "InProc" : "InProc"});

SPLM.Mechatronics.OPCClientBuilder.TagDataType = Object.freeze({
    "Unknown" : "Unknown", "Integer" : "Integer", "Float" : "Float", "Boolean" : "Boolean"});

SPLM.Mechatronics.OPCClientBuilder.TagAccess = Object.freeze({
    "ReadOnly" : "ReadOnly", "WriteOnly" : "WriteOnly", "ReadWrite" : "ReadWrite"});

SPLM.Mechatronics.OPCClientBuilder.UpdateMethod = Object.freeze({
    "AsynchRead" : "AsynchRead", "Subscription" : "Subscription"});

export default SPLM;